import styled from "styled-components";
import { COMPONENTS, SPACING } from "../../constants/design/spacing";
import {
  BORDER_COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";

// Full-height page: fixed summary header on top, scrollable list of
// strategy panels below.
export const StrategiesPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${COMPONENTS.header.main}px);
  overflow: hidden;
  background: ${LAYER_COLORS.one};
`;

export const SummaryBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${SPACING.four}px;
  padding: ${SPACING.three}px;
  border-bottom: 1px solid ${BORDER_COLORS.one};
`;

export const SummaryStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.one}px;

  > span:first-child {
    ${FONT_CSS.label.two}
    color: ${TEXT_COLORS.two};
    white-space: nowrap;
  }

  > span:last-child {
    ${FONT_CSS.label.one}
    color: ${TEXT_COLORS.one};
    font-weight: 600;
    white-space: nowrap;
  }
`;

export const StrategiesList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${SPACING.three}px;
  display: flex;
  flex-direction: column;
  gap: ${SPACING.three}px;
`;

// Grid of per-strategy scalar stats rendered above the accounts table
// inside each expanded panel.
export const StrategyStatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: ${SPACING.three}px;
  padding: ${SPACING.three}px;
  border-bottom: 1px solid ${BORDER_COLORS.one};
`;

export const StrategyStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.one}px;

  > span {
    ${FONT_CSS.label.two}
    color: ${TEXT_COLORS.two};
  }

  > div {
    ${FONT_CSS.label.one}
    color: ${TEXT_COLORS.one};
    word-break: break-all;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  ${FONT_CSS.label.two}
  color: ${TEXT_COLORS.two};
`;

// Panel header: strategy name + address on the left, count tags on the right.
export const PanelLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.three}px;
  width: 100%;
`;

export const PanelTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.one}px;

  > span:first-child {
    ${FONT_CSS.label.one}
    color: ${TEXT_COLORS.one};
    font-weight: 600;
  }

  > span:last-child {
    ${FONT_CSS.label.two}
    color: ${TEXT_COLORS.two};
  }
`;

export const PanelTags = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${SPACING.two}px;
  margin-right: ${SPACING.three}px;
`;
